import React from 'react';
import { AchRelationshipsTable } from '@widgets/AchRelationshipsTable';

export const AchRelationshipsPage: React.FC = () => {
    return <AchRelationshipsTable />;
};
